// src/language/expensesLanguage.js
const expensesLanguage = {
  en: {
    pageTitle: "Expenses",
    tabPurchaseMilk: "Purchase Milk",
    tabOtherExpenses: "Other Expenses",

    // Purchase Milk fields
    name: "Name",
    milkType: "Milk Type",
    milkTypeCow: "Cow",
    milkTypeBuffalo: "Buffalo",
    quantity: "Quantity (Liters)",
    rate: "Rate (₹/Liter)",
    date: "Date",
    save: "Save",
    update: "Update",
    cancel: "Cancel",

    // Other Expenses fields
    productType: "Product Type",
    productAmount: "Amount (₹)",

    // Table headers
    recentEntries: "Recent Entries",
    colDate: "Date",
    colName: "Name",
    colType: "Type",
    colQty: "Qty (L)",
    colRate: "Rate (₹)",
    colTotal: "Total (₹)",
    colProduct: "Product",
    colAmount: "Amount (₹)",
    colActions: "Actions",

    // Messages
    validationError: "Validation Error",
    success: "Success",
    error: "Error",
    savedSuccess: "Entry saved successfully!",
    updatedSuccess: "Entry updated successfully!",
    deletedSuccess: "Entry deleted successfully!",
    saveFailed: "Failed to save entry.",
    deleteFailed: "Failed to delete entry.",
    deleteConfirmTitle: "Delete Entry",
    deleteConfirmMsg: "Are you sure you want to delete this entry? This action cannot be undone.",
    purchaseMilkValidation: "Please enter name, quantity and rate.",
    expensesValidation: "Please enter product type and amount.",
    saving: "Saving...",
    noEntries: "No entries yet.",
    delete: "Delete",
    deleteCancel: "Cancel",
  },
  mr: {
    pageTitle: "खर्च",
    tabPurchaseMilk: "दूध खरेदी",
    tabOtherExpenses: "इतर खर्च",

    // Purchase Milk fields
    name: "नाव",
    milkType: "दूध प्रकार",
    milkTypeCow: "गायीचे",
    milkTypeBuffalo: "म्हशीचे",
    quantity: "प्रमाण (लिटर)",
    rate: "दर (₹/लिटर)",
    date: "तारीख",
    save: "सेव्ह करा",
    update: "अपडेट करा",
    cancel: "रद्द करा",

    // Other Expenses fields
    productType: "उत्पादन प्रकार",
    productAmount: "रक्कम (₹)",

    // Table headers
    recentEntries: "अलीकडील नोंदी",
    colDate: "तारीख",
    colName: "नाव",
    colType: "प्रकार",
    colQty: "प्रमाण (ली)",
    colRate: "दर (₹)",
    colTotal: "एकूण (₹)",
    colProduct: "उत्पादन",
    colAmount: "रक्कम (₹)",
    colActions: "क्रिया",

    // Messages
    validationError: "प्रमाणीकरण त्रुटी",
    success: "यशस्वी",
    error: "त्रुटी",
    savedSuccess: "नोंद यशस्वीरित्या जतन केली!",
    updatedSuccess: "नोंद यशस्वीरित्या अपडेट केली!",
    deletedSuccess: "नोंद यशस्वीरित्या हटवली!",
    saveFailed: "नोंद जतन करण्यात अयशस्वी.",
    deleteFailed: "नोंद हटवण्यात अयशस्वी.",
    deleteConfirmTitle: "नोंद हटवा",
    deleteConfirmMsg: "तुम्हाला खात्री आहे की तुम्ही ही नोंद हटवू इच्छिता? ही क्रिया परत घेता येत नाही.",
    purchaseMilkValidation: "कृपया नाव, प्रमाण आणि दर भरा.",
    expensesValidation: "कृपया उत्पादन प्रकार आणि रक्कम भरा.",
    saving: "जतन करत आहे...",
    noEntries: "अद्याप कोणत्याही नोंदी नाहीत.",
    delete: "हटवा",
    deleteCancel: "रद्द करा",
  },
};

export default expensesLanguage;
